// Shared by the admin preview and the server. Amounts use nearest-cent rounding.
export const MAX_PRICE = 999999.99;
const missing = (value) => value == null || (typeof value === 'string' && !value.trim());
const number = (value, label) => {
  if (missing(value) || !['number', 'string'].includes(typeof value) || !Number.isFinite(Number(value))) {
    throw new Error(`${label} must be a finite number.`);
  }
  return Number(value);
};

export function calculateMarginPrice(cost, margin) {
  const c = number(cost, 'Cost');
  const m = number(margin, 'Profit margin');
  if (c <= 0 || c > MAX_PRICE) throw new Error(`Cost must be greater than 0 and at most ${MAX_PRICE}.`);
  if (m < 0 || m >= 100) throw new Error('Profit margin must be at least 0 and below 100%.');
  const result = Math.round((c / (1 - m / 100) + Number.EPSILON) * 100) / 100;
  if (!Number.isFinite(result) || result <= 0 || result > MAX_PRICE) throw new Error(`Selling price must be between 0.01 and ${MAX_PRICE}.`);
  return result;
}

export function resolveProductPricing(input, current = {}) {
  const merged = { ...current, ...input };
  const method = merged.pricingMethod || 'manual';
  if (!['manual', 'margin'].includes(method)) throw new Error('Invalid pricing method.');
  if (method === 'manual') return { ...input, pricingMethod: method };
  const price = calculateMarginPrice(merged.costPrice, merged.profitMargin);
  const result = {
    ...input, pricingMethod: method, costPrice: Number(merged.costPrice),
    profitMargin: Number(merged.profitMargin), price,
    costSource: merged.costSource === 'supplier-api' ? 'supplier-api' : 'admin',
  };
  for (const field of ['skus', 'colorsVariants']) {
    result[field] = (merged[field] || []).map((variant, index) => {
      const v = { ...variant };
      if (v.useBasePrice === true || (missing(v.costPrice) && missing(v.price))) {
        return { ...v, useBasePrice: true, costPrice: undefined, price: undefined };
      }
      try {
        return { ...v, useBasePrice: false, costPrice: number(v.costPrice, 'Variant cost'), price: calculateMarginPrice(v.costPrice, merged.profitMargin) };
      } catch (error) { throw new Error(`${field} ${index + 1}: ${error.message}`); }
    });
  }
  return result;
}
